var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9468 32.7126C54.9468 20.7688 45.1426 10.9646 33.1989 10.9646C21.2551 10.9646 11.451 20.7688 11.451 32.7126C11.451 44.6563 21.2551 54.4605 33.1989 54.4605C45.1426 54.4605 54.9468 44.6563 54.9468 32.7126ZM60.2822 32.7126C60.2822 47.7167 48.2031 59.7959 33.1989 59.7959C18.1947 59.7959 6.11555 47.7167 6.11555 32.7126C6.11555 17.7084 18.1947 5.62923 33.1989 5.62923C48.2031 5.62923 60.2822 17.7084 60.2822 32.7126ZM37.3697 35.4209L37.3697 43.5459L48.0947 32.7126L37.3697 21.8792L37.3697 30.0042L18.3031 30.0042L18.3031 35.4209",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.d4c1628539dd85de622ae13200de3699.svg";
export { ForwardRef as ReactComponent };